import * as React from 'react';
import { warnOnce } from '../../utils';
const defaultValue = {
    onChange() {
        warnOnce(`RadioGroupContext.Consumers 'onChange' callback, invoked without RadioGroupContext.Provider`);
    },
};
export const { Provider: RadioGroupContextProvider, Consumer: RadioGroupContextConsumer } = React.createContext(defaultValue);
//# sourceMappingURL=RadioGroupContext.js.map